<template>
  <div class="payment-module-cc-container">
    <credit-card-item v-if="paymentData" :data="paymentData" />

    <div
      class="payment-module-cc-container__link"
      @click="$emit('changeSavedPayment', 'bluesnap_cc')"
    >
      Change card
    </div>
  </div>
</template>

<script>
import CreditCardItem from '@/components/payment/CreditCardItem.vue'

export default {
  name: 'BluesnapCreditCardMethod',
  components: {
    CreditCardItem,
  },
  props: {
    paymentData: {
      type: Object,
      required: false,
      default: null,
    },
  },
  methods: {
    validate () {
      return this.paymentData !== null
    },
  },
}
</script>

<style lang="scss" scoped>
.payment-module-cc-container {
  &::v-deep .cg-loader {
    margin: 0 auto;
  }

  &__link {
    font-family: 'Lato-Regular', sans-serif;
    font-weight: 400;
    font-size: 15px;
    margin-top: 14px;
    line-height: 18px;
    color: #42B77A;
    cursor: pointer;
    width: fit-content;
  }

  &::v-deep .credit-card-item {
    border: 1px solid #D3D2D2;
    cursor: default;
    background-color: #fff;

    &__actions {
      display: none;
    }
  }
}
</style>
